function steps() {
    document.body.addEventListener('click', function (event) {
        if (event.target.matches('.apply .items li')) {
            document.querySelectorAll('.apply .active').forEach(el => el.classList.remove('active'));
            var item = event.target.getAttribute('item');
            event.target.classList.add('active');
            document.getElementById(item).classList.add('active');
        }
    });
}
steps();

function toggle() {
    var widest = 0;
    document.querySelectorAll('.toggle .option').forEach(function (el) {
        widest = Math.max(widest, el.offsetWidth);
    });
    document.querySelectorAll('.toggle .option').forEach(function (el) {
        el.style.width = widest + 'px';
    });

    document.body.addEventListener('click', function (event) {
        if (event.target.matches('.toggle .d-flex .option')) {
            document.querySelector('.toggle .d-flex .option.active').classList.remove('active');
            document.querySelector('.applyform.active').classList.remove('active');
            var option = event.target.getAttribute('option');
            var item = event.target.getAttribute('item');
            event.target.classList.add('active');
            event.target.closest('.d-flex').id = option;
            document.getElementById(item).classList.add('active');
        }
    });
}
toggle();

function view() {
    function setCookie(name, value, lifetime_days) {
        var exp = new Date();
        exp.setDate(new Date().getDate() + lifetime_days);
        document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function toggleClass(element, class1, class2) {
        if (element.classList.contains(class1)) {
            element.classList.remove(class1);
            element.classList.add(class2);
        } else {
            element.classList.remove(class2);
            element.classList.add(class1);
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        var currentView = getCookie('view');
        if (currentView === 'list') {
            document.querySelectorAll('.views').forEach(function (el) {
                el.classList.add('col-12');
            });
        } else if (currentView === 'grid') {
            document.querySelectorAll('.views').forEach(function (el) {
                el.classList.remove('col-12');
                el.classList.add('col-6', 'grid-col');
            });
        }

        document.body.addEventListener('click', function (event) {
            if (event.target.matches('.toggle-list')) {
                setCookie('view', 'list', 7);
                document.querySelectorAll('.views').forEach(function (el) {
                    el.classList.remove('col-6', 'grid-col');
                    el.classList.add('col-12');
                });
                toggleClass(event.target, 'toggle-list', 'toggle-grid');
            } else if (event.target.matches('.toggle-grid')) {
                setCookie('view', 'grid', 7);
                document.querySelectorAll('.views').forEach(function (el) {
                    el.classList.remove('col-12');
                    el.classList.add('col-6', 'grid-col');
                });
                toggleClass(event.target, 'toggle-list', 'toggle-grid');
            }
        });
    });


}
view();

function anchor() {
    let menuSection = document.querySelectorAll('.anchor-nav.nav-items li');
    menuSection.forEach(v => {
        v.onclick = (() => {
            setTimeout(() => {
                menuSection.forEach(j => j.classList.remove('active'));
                v.classList.add('active');
            }, 300);
        });
    });

    window.onscroll = (() => {
        let mainSection = document.querySelectorAll('section.tagged');
        mainSection.forEach((v, i) => {
            let rect = v.getBoundingClientRect().y;
            if (rect < window.innerHeight - 700) {
                menuSection.forEach(v => v.classList.remove('active'));
                menuSection[i].classList.add('active');
            }
        });
    });

    document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(anchor => {
        anchor.addEventListener('click', function (event) {
            event.preventDefault();
            var target = document.querySelector(this.hash);
            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 150,
                    behavior: 'smooth'
                });
            }
        });
    });

    if (location.hash) {
        var id = document.querySelector(location.hash);
    }

    window.addEventListener('load', function () {
        if (location.hash) {
            window.scrollTo({
                top: id.offsetTop - 300,
                behavior: 'smooth'
            });
        }
    });
}
anchor();

function mobileNav() {
    document.body.addEventListener('click', function (event) {
        if (event.target.matches('.mobile-nav__toggle')) {
            var mobileNav = document.getElementById('mobile-nav');
            document.body.classList.toggle('mobile-nav__open');
        } else if (event.target.matches('.menu-item-has-children')) {
            var submenu = event.target.querySelector('ul');
            if (submenu) {
                submenu.style.display = submenu.style.display === 'none' || submenu.style.display === '' ? 'block' : 'none';
            }
        }
    });
}
mobileNav();

function applyTabs() {
    document.addEventListener('DOMContentLoaded', function () {
        var scrollArea = document.querySelector('.apply .items');
        var toScroll = document.querySelectorAll('.apply .items li');
        toScroll.forEach(function (item) {
            item.style.cursor = 'pointer';
            item.addEventListener('click', function () {
                var leftOffset = item.offsetLeft - scrollArea.offsetLeft + scrollArea.scrollLeft;
                scrollArea.scrollTo({ left: leftOffset, behavior: 'smooth' });
            });
        });
    });
}
applyTabs();

function blogFilters() {
    document.addEventListener('DOMContentLoaded', function () {
        var scrollArea = document.querySelector('.blog-filter-items');
        var toScroll = document.querySelectorAll('.blog-filter-items a.current');
        toScroll.forEach(function (item) {
            item.style.cursor = 'pointer';
            var leftOffset = item.offsetLeft - scrollArea.offsetLeft + scrollArea.scrollLeft;
            scrollArea.scrollTo({ left: leftOffset, behavior: 'smooth' });
        });
    });
}
blogFilters();

function cvToggle() {
    document.addEventListener('DOMContentLoaded', function () {
        var cvToggle = document.querySelector('.cvToggle');
        if (cvToggle) {
            cvToggle.addEventListener('click', function (event) {
                var cvBlock = document.querySelector('.cvBlock');
                if (cvBlock) {
                    cvBlock.style.display = cvBlock.style.display === 'none' || cvBlock.style.display === '' ? 'block' : 'none';
                }
            });
        }
    });
}
cvToggle();

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.worker-container').forEach(function (container) {
        var aboutWorker = container.querySelector('.about-worker');
        var lineHeight = parseInt(window.getComputedStyle(aboutWorker).lineHeight);
        var maxLines = 2;
        var originalHeight = lineHeight * maxLines;

        aboutWorker.style.height = originalHeight + 'px';

        var fullHeight = aboutWorker.scrollHeight;

        if (fullHeight > originalHeight) {
            var readMoreBtn = container.querySelector('.read-more-btn');
            readMoreBtn.style.display = 'block';

            readMoreBtn.addEventListener('click', function () {
                if (aboutWorker.classList.contains('expanded')) {
                    aboutWorker.style.height = originalHeight + 'px';
                    aboutWorker.classList.remove('expanded');
                    readMoreBtn.classList.remove('hide');
                    readMoreBtn.classList.add('show');
                } else {
                    aboutWorker.style.height = fullHeight + 'px';
                    aboutWorker.classList.add('expanded');
                    readMoreBtn.classList.add('hide');
                    readMoreBtn.classList.remove('show');
                }
            });
        }
    });
});

function notificationBar() {
    function setCookie(name, value, lifetime_days) {
        var exp = new Date();
        exp.setDate(exp.getDate() + lifetime_days);
        document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
    }
    document.addEventListener('DOMContentLoaded', function () {
        const notificationBar = document.querySelector(".notification-bar");
        const closeButton = document.querySelector(".close");
        if (notificationBar && closeButton) {
            closeButton.onclick = function () {
                notificationBar.style.height = notificationBar.offsetHeight + 'px';
                notificationBar.offsetHeight;
                setTimeout(function () {
                    notificationBar.style.height = '0px';
                }, 2);
                setCookie('notificationBar', 'hidden', 7);
            };
        }
    });
}
notificationBar();

function accordions() {
    const accordions = document.querySelectorAll(".accordion");

    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".accordion__content");
        accordion.classList.add("accordion__active");
        content.style.maxHeight = content.scrollHeight + "px";
    };

    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".accordion__content");
        accordion.classList.remove("accordion__active");
        content.style.maxHeight = null;
    };

    accordions.forEach((accordion) => {
        const intro = accordion.querySelector(".accordion__intro");
        const content = accordion.querySelector(".accordion__content");

        intro.onclick = () => {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach((accordion) => closeAccordion(accordion));
                openAccordion(accordion);
            }
        };
    });

}
accordions();

function filters() {
    function toggleFilterItems(event) {
        var target = event.target;
        // Controleer of het geklikte element een .title binnen .uzp__category is
        if (target.classList.contains('title')) {
            target.classList.toggle('open');
            var filterItems = target.nextElementSibling;
            if (filterItems.classList.contains('filter-items')) {
                filterItems.classList.toggle('open');
                if (filterItems.classList.contains('open')) {
                    filterItems.style.display = 'block';
                } else {
                    filterItems.style.display = 'none';
                }
            }
        }
    }
    document.body.addEventListener('click', toggleFilterItems);
    document.querySelectorAll('.uzp__category').forEach(function (category) {
        var name = category.querySelector('.active').getAttribute('name');
        category.querySelector('.title').innerHTML = name;
    });
}
filters();


function methods() {
    let methodItems = document.querySelectorAll('.method li');
    methodItems.forEach(item => {
        item.onclick = (() => {
            let activeItems = document.querySelectorAll('.active');
            activeItems.forEach(item => {
                item.classList.remove('active');
            });

            item.classList.add('active');

            let id = item.getAttribute('item');
            let contentDiv = document.getElementById(id);
            contentDiv.classList.add('active');

        });
    });
}
methods()
